import React, { useContext } from 'react';
import classnames from 'classnames';
import { Helmet } from 'react-helmet-async';
import { Url } from '@wix/da-url';
import { getGlobalClassnamesForContext } from '@wix/da-react-context/pkg/helpers';
import { ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import { getRobotsContent } from '../../utils/head';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { AdProviders } from '@wix/da-ads/pkg/constants';
const Head = ({ pageTitle = 'DeviantArt', pageDescription = "DeviantArt is the world's largest online social community for artists and art enthusiasts, allowing people to connect through the creation and sharing of art.", pageRating, pageUrl, pageThumb = Url.staticCDNLink('minish/main/logo/card_black_large.png'), isMobile, isIOS, environment, language, prevUrl, nextUrl, theme, flags, themeSkin, bodyClassName, hasNewChatMessage })=>{
    var _adProviders;
    const { isLoggedIn, adsEnabled, adProviders } = useContext(SessionContext);
    const isFreestar = (_adProviders = adProviders) === null || _adProviders === void 0 ? void 0 : _adProviders.includes(AdProviders.Freestar);
    return /*#__PURE__*/ React.createElement(Helmet, {
        htmlAttributes: {
            lang: language
        },
        bodyAttributes: {
            class: classnames(getGlobalClassnamesForContext({
                isMobile,
                theme,
                flags,
                themeSkin,
                isLoggedIn,
                adsEnabled
            }), bodyClassName)
        }
    }, /*#__PURE__*/ React.createElement("meta", {
        charSet: "utf-8"
    }), /*#__PURE__*/ React.createElement("title", null, pageTitle), preconnectDomains(isFreestar), preloadFonts(), /*#__PURE__*/ React.createElement("link", {
        rel: "apple-touch-icon",
        sizes: "180x180",
        href: Url.staticCDNLink('eclipse/icons/ios-180.png')
    }), /*#__PURE__*/ React.createElement("link", {
        rel: "apple-touch-icon",
        sizes: "152x152",
        href: Url.staticCDNLink('eclipse/icons/ios-152.png')
    }), /*#__PURE__*/ React.createElement("link", {
        rel: "apple-touch-icon",
        sizes: "120x120",
        href: Url.staticCDNLink('eclipse/icons/ios-120.png')
    }), /*#__PURE__*/ React.createElement("link", {
        rel: "apple-touch-icon",
        sizes: "76x76",
        href: Url.staticCDNLink('eclipse/icons/ios-76.png')
    }), /*#__PURE__*/ React.createElement("link", {
        rel: "icon",
        sizes: "192x192",
        href: Url.staticCDNLink('eclipse/icons/android-192.png')
    }), /*#__PURE__*/ React.createElement("link", {
        rel: "icon",
        sizes: "144x144",
        href: Url.staticCDNLink('eclipse/icons/android-144.png')
    }), /*#__PURE__*/ React.createElement("link", {
        rel: "icon",
        sizes: "96x96",
        href: Url.staticCDNLink('eclipse/icons/android-96.png')
    }), /*#__PURE__*/ React.createElement("link", {
        rel: "icon",
        sizes: "48x48",
        href: Url.staticCDNLink('eclipse/icons/android-48.png')
    }), /*#__PURE__*/ React.createElement("link", {
        rel: "mask-icon",
        href: Url.staticCDNLink('eclipse/icons/touchbar-mark-v2.svg'),
        color: "#00e59b"
    }), /*#__PURE__*/ React.createElement("link", {
        rel: "icon",
        sizes: "16x16",
        type: "image/png",
        href: Url.staticCDNLink('eclipse/icons/favicon-v2-16x16.png')
    }), /*#__PURE__*/ React.createElement("link", {
        rel: "icon",
        sizes: "32x32",
        type: "image/png",
        href: Url.staticCDNLink('eclipse/icons/favicon-v2-32x32.png')
    }), /*#__PURE__*/ React.createElement("link", {
        href: getFavIcon(environment, hasNewChatMessage),
        rel: "shortcut icon"
    }), /*#__PURE__*/ React.createElement("link", {
        rel: "canonical",
        href: Url.buildFromPath(pageUrl)
    }), prevUrl && /*#__PURE__*/ React.createElement("link", {
        href: prevUrl,
        rel: "prev"
    }), nextUrl && /*#__PURE__*/ React.createElement("link", {
        href: nextUrl,
        rel: "next"
    }), /*#__PURE__*/ React.createElement("meta", {
        name: "application-name",
        content: "DeviantArt"
    }), /*#__PURE__*/ React.createElement("meta", {
        name: "description",
        content: pageDescription
    }), /*#__PURE__*/ React.createElement("meta", {
        name: "robots",
        content: getRobotsContent()
    }), /*#__PURE__*/ React.createElement("meta", {
        property: "og:type",
        content: "website"
    }), /*#__PURE__*/ React.createElement("meta", {
        property: "og:url",
        content: Url.buildFromPath(pageUrl)
    }), /*#__PURE__*/ React.createElement("meta", {
        property: "og:title",
        content: pageTitle
    }), /*#__PURE__*/ React.createElement("meta", {
        property: "og:image",
        content: pageThumb
    }), /*#__PURE__*/ React.createElement("meta", {
        property: "og:description",
        content: pageDescription
    }), /*#__PURE__*/ React.createElement("meta", {
        property: "fb:page_id",
        content: "6452638289"
    }), /*#__PURE__*/ React.createElement("meta", {
        property: "twitter:account_id",
        content: "1239671"
    }), /*#__PURE__*/ React.createElement("meta", {
        name: "twitter:site",
        content: "@deviantart"
    }), /*#__PURE__*/ React.createElement("meta", {
        name: "twitter:card",
        content: "summary_large_image"
    }), /*#__PURE__*/ React.createElement("meta", {
        name: "twitter:title",
        content: pageTitle
    }), /*#__PURE__*/ React.createElement("meta", {
        name: "twitter:description",
        content: pageDescription
    }), /*#__PURE__*/ React.createElement("meta", {
        name: "twitter:image",
        content: pageThumb
    }), /*#__PURE__*/ React.createElement("meta", {
        name: "pinterest",
        content: "nopin"
    }), /*#__PURE__*/ React.createElement("meta", {
        name: "theme-color",
        content: theme === ThemeOptions.DARK ? '#06070d' : '#ffffff'
    }), pageRating && /*#__PURE__*/ React.createElement("meta", {
        name: "rating",
        content: pageRating
    }), isMobile && /*#__PURE__*/ React.createElement("meta", {
        name: "viewport",
        content: `width=device-width, initial-scale=1${isIOS ? ', maximum-scale=1' : ''}`
    }));
};
Head.displayName = 'Head';
// We preload just the woff2, they are better compressed and have good support
// especially on browsers that support preload :)
function preloadFonts() {
    const fonts = [
        [
            Url.staticCDNLink('misc/symbols/deviantart-symbols6.woff2'),
            'font/woff2'
        ],
        [
            Url.staticCDNLink('misc/symbols/deviantart-symbols-v7.woff2'),
            'font/woff2'
        ],
        [
            Url.staticCDNLink('fonts/devioussans-1-110/devioussans_w_bd.woff2'),
            'font/woff2'
        ],
        [
            Url.staticCDNLink('fonts/devioussans-1-110/devioussans_w_xbd.woff2'),
            'font/woff2'
        ],
        [
            Url.staticCDNLink('fonts/devioussans-1-110/devioussans_w_lt.woff2'),
            'font/woff2'
        ],
        [
            Url.staticCDNLink('fonts/devioussans-1-110/devioussans_w_md.woff2'),
            'font/woff2'
        ],
        [
            Url.staticCDNLink('fonts/devioussans-1-110/devioussans_w_rg.woff2'),
            'font/woff2'
        ]
    ];
    return fonts.map((font)=>/*#__PURE__*/ React.createElement("link", {
            key: font[0],
            rel: "preload",
            href: font[0],
            as: "font",
            type: font[1],
            crossOrigin: 'anonymous'
        }));
}
function preconnectDomains(isFreestar) {
    const domains = [
        'https://a.deviantart.net',
        'https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com',
        'https://st.deviantart.net',
        'https://hub.deviantart.net',
        'https://static.parastorage.com',
        'https://www.wix.com',
        'https://frog.wix.com',
        'https://securepubads.g.doubleclick.net'
    ];
    if (isFreestar) {
        domains.push('https://a.pub.network', 'https://b.pub.network', 'https://c.pub.network', 'https://d.pub.network', 'https://secure.quantserve.com', 'https://rules.quantcount.com', 'https://pixel.quantserve.com', 'https://cmp.quantcast.com', 'https://btloader.com', 'https://api.btloader.com', 'https://confiant-integrations.global.ssl.fastly.net');
    }
    return domains.map((domain)=>/*#__PURE__*/ React.createElement("link", {
            key: domain,
            rel: "preconnect",
            href: domain
        }));
}
function getFavIcon(env, hasNewChatMessage) {
    if (hasNewChatMessage) {
        switch(env){
            // same icon for dev / rc
            case 'dev':
            case 'rc':
                return Url.staticCDNLink('eclipse/icons/favicon-dot-staging_32x32.png');
            default:
                return Url.staticCDNLink('eclipse/icons/favicon-dot_32x32.png');
        }
    }
    switch(env){
        case 'dev':
            return Url.staticCDNLink('eclipse/icons/da_favicon_vm_v2.ico?1');
        case 'rc':
            return Url.staticCDNLink('eclipse/icons/da_favicon_staging_v2.ico');
        default:
            return Url.staticCDNLink('eclipse/icons/da_favicon_v2.ico');
    }
}
export default Head;
